import { createSelector } from 'reselect'

const uiState = (state: any) => state.ui

export const selectActivePoint = createSelector(
  [uiState],
  (ui: any) => ui.activePoint
)

export const selectDraggedPoint = createSelector(
  [uiState],
  (ui: any) => ui.draggedPoint
)
